/**
 * Les services
 */
export const storageService = [
    {
        title: "tarif réparation",
        text: "A partir de 39,90€",
        image: {
            src: require("assets/images/reparation_tel.png"),
            alt: "Un téléphone avec un écran cassé qui a été réparé"
        }
    },
    {
        title: "e-liquides",
        text: "A partir de 4,90€",
        image: {
            src: require("assets/images/petit_verger.jpg"),
            alt: "Une pose de plomberie"
        }
    },
    {
        title: "service d'installation multimédia",
        text: "Tarif sur devis",
        image: {
            src: require("assets/images/fixer-tv-mur.jpg"),
            alt: "Une pose de plomberie"
        }
    },
]

/**
 * Carousel
 */
export const storageCarousel = [
    {
        title: "« Très bonne équipe qui prend le temps de bien expliquer ses produits. Je recommande. »",
        author: "Clement Bacque"
    },
    {
        title: "« Super réparateur pas très cher l’accueil très chaleureux. »",
        author: "Zina Mokaouim"
    },
    {
        title: "« Réparation rapide et efficace. Merci beaucoup ! »",
        author: "Norah Claverie"
    }
]


/**
 * Galery
 */
export const storageGalery = [
    {
        title: "Installation verrière",
        image: {
            src: require("assets/images/cig_elec.jpg"),
            alt: "Installation d'une verrière "
        },
        tags: ["peinture", "sol & murs", "pose menuiserie"]
    },
    {
        title: "Installation verrière",
        image: {
            src: require("assets/images/cig_elec.jpg"),
            alt: "Installation d'une verrière "
        },
        tags: ["carrelage", "éléctricité", "isolations", "pose menuiserie"]
    },
]